















































































































































































































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

import CabeceraModal from '@/reusable/Modal/CabeceraModal.vue';
import ModalMantenedor from '@/reusable/Modal/ModalMantenedor.vue';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import MantenedorGridSinCodigo from '@/reusable/Grid/MantenedorGridSinCodigo.vue';
import MantenedorGrid from '@/reusable/Grid/MantenedorGrid.vue';
import {
  GridOptions,
  GridApi,
  ColumnApi,
  ColDef,
  GridReadyEvent,
  ICellRendererParams,
  RowNode,
} from 'ag-grid-community';
import { AlertaGrilla } from '@/pantallas/Camaras/Alertas/fetchAlerta';
import { LoadingService } from '@/services/loadingService';
import { Snotify } from '@/snotify/Snotify';
import { Validator } from 'vee-validate';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import TimePicker from '@/reusable/Form/TimePicker.vue';
import moment from 'moment';
import { fetchOrdenesCompra } from './fetchOrdenesCompra';
import Confirmation from '@/components/Confirmation.vue';
import ValidaRut from '@/config/validaRut';
import config from '@/config/index';
import { EstadoGrillaVm } from '@/interfaces/EstadoGrillaVm';
import { Funcionalidades } from '@/config/funcionalidades';
import { add, indexOf } from 'lodash';
import { actionsEvent } from '@/setup';
import { number } from 'yup';

@Component({
  components: {
    MantenedorGridSinCodigo,
    MantenedorGrid,
    CabeceraModal,
    ModalMantenedor,
    FormFieldsContainer,
    DatePicker,
    'app-confirmacion': Confirmation,
  },
})
export default class modalCrearOC extends Vue {
  @Prop({ default: true }) show: boolean;
  @Prop({ required: true }) editable: any;
  @Prop({ required: true }) editableEq: any;
  @Prop({ default: null }) id_orden_compra: any; // VALOR RECIBIDO DESDE LA PANTALLA ANTERIOR. LO USAMOS PARA VER SI ES CREACION O EDICION

  //@Prop({ default: null }) po_sel: any;
  //@Prop({ default: null }) IdProv: any;
  //@Prop({ default: null }) INETBodega: any;
  //@Prop({ default: null }) INETCuenta: any;
  //@Prop({ default: null }) opera: any;
  rut_proveedor: string = '';

  handleProveedorChange() {
    this.changeProveedor();
  }
  esInternacional: boolean = false;
  changeProveedor() {
    let proveedorSelected = this.rut_proveedor;
    let tipoSelected = this.lista_proveedores.find(
      (e: any) => e.proveedorrut === proveedorSelected
    );
    if (tipoSelected && tipoSelected.proveedortipo == 'Y') {
      this.columnApi.setColumnVisible('conversion', true);
      this.esInternacional = true;
      this.updateDolar();
    } else if (tipoSelected) {
      this.columnApi.setColumnVisible('conversion', false);
      this.esInternacional = false;
    }
  }

  descrip: any = '';
  valor_id_orden_compra: any = 'Por Asignar'; //valor con el id. calculado por un MS (get_proximo_id_ms) usado para cargar el id que usara en el textbox y el es valor que se envia en el crear
  fecha_alta: any = '';
  fecha_llegada: any = '';
  rut_contable: any = '';
  equipo: any = '';
  estado: any = '';
  observacion: String = '';
  solicitadoPor: String = '';
  flete: any = '';
  precioDolar: any = '';
  cantidad: any = '';
  precio: any = '';
  lista_equipos: any = [];
  lista_estados: any = [];
  lista_proveedores: any = [];
  lista_InetOpera: any = [];
  bloquea_dropdown_estado: boolean = false;
  deshabilitado: boolean = false;
  archivoB64: any = '';
  fileName: any = '';
  mostrarModalCONFIRMAR: boolean = false;
  Modal_confirmar_TEXTO: any = '';
  dictionaryFormErrors: any = {};
  vr: ValidaRut = new ValidaRut();
  gridOptions: GridOptions;
  gridApi: GridApi;
  columnApi: ColumnApi;
  columnDefs: Array<ColDef> = [];
  estadoGrillaVm: EstadoGrillaVm;
  serverSide: any;

  updateFlete() {
    let tipoCambio = 0;
    if (this.precioDolar && this.precioDolar != '') {
      tipoCambio = parseFloat(
        this.precioDolar.replace('.', '').replace(',', '.')
      );
    }
    let precioFlete = 0;
    if (this.flete != '' && this.flete) {
      precioFlete = parseFloat(this.flete.replace('.', ''));
      if (precioFlete < 0) {
        this.flete = this.formatNumber('0');
        precioFlete = 0;
      } else {
        this.flete = this.formatNumber(this.flete);
      }
    } else {
      this.flete = 0;
    }
    if (this.loadedSeries.length > 0) {
      let cantidadTotal = this.loadedSeries.reduce((acumulador, objeto) => {
        return acumulador + parseInt(objeto.cantidad);
      }, 0);
      let fleteValue: any = '';
      let finalValue: boolean = false;
      if (isNaN(precioFlete) || precioFlete == 0) {
        fleteValue = 'No ingresado flete';
      } else {
        finalValue = true;
        fleteValue = (precioFlete / parseInt(cantidadTotal)).toFixed(2);
      }
      this.loadedSeries = this.loadedSeries.map((e: any) => {
        return {
          ...e,
          precioTotal: finalValue
            ? (parseFloat(e.precio) + parseFloat(fleteValue)) *
              parseFloat(e.cantidad)
            : parseFloat(e.precio) * parseFloat(e.cantidad),
          precioFlete: fleteValue,
          conversion: finalValue
            ? (parseFloat(e.precio) + parseFloat(fleteValue)) *
              parseFloat(e.cantidad) *
              (tipoCambio != 0 ? tipoCambio : 1)
            : e.conversion,
        };
      });
      this.gridApi.setRowData(this.loadedSeries);
    }
  }
  updateDolar() {
    let precioDolar = 0;
    if (this.precioDolar != '' && this.precioDolar) {
      precioDolar = parseFloat(
        this.precioDolar.replace('.', '').replace(',', '.')
      );
      this.precioDolar = this.formatNumber(this.precioDolar);
    }
    let precioFlete = 0;
    if (this.flete != '' && this.flete) {
      precioFlete = parseFloat(this.flete.replace('.', ''));
      this.flete = this.formatNumber(this.flete);
    } else {
      this.flete = 0;
    }

    if (this.loadedSeries.length > 0) {
      let cantidadTotal = this.loadedSeries.reduce((acumulador, objeto) => {
        return acumulador + parseInt(objeto.cantidad);
      }, 0);
      let fleteValue = (precioFlete / parseInt(cantidadTotal)).toFixed(2);
      this.loadedSeries = this.loadedSeries.map((e: any) => {
        return {
          ...e,
          conversion:
            isNaN(precioDolar) || precioDolar == 0
              ? 'No ingresado tipo de cambio'
              : (parseFloat(e.precio) + parseFloat(fleteValue)) *
                parseFloat(e.cantidad) *
                precioDolar,
          precioTotal:
            parseFloat(e.cantidad) *
            (parseFloat(e.precio) + parseFloat(fleteValue)),
        };
      });
      this.gridApi.setRowData(this.loadedSeries);
    }
  }

  readonly $snotify: Snotify;
  funcionalidad: Funcionalidades = Funcionalidades.TablaVerSeriesOrdenDeCompra;
  loadedSeries: Array<any> = [];
  comprobarEdicionEquipos() {
    return (
      (this.editable == 'INGRESADO' && this.editableEq) ||
      this.editable === null
    );
  }

  addDevice() {
    if (!this.precio || !this.cantidad || !this.equipo) {
      this.$snotify.error('Por favor agregue todos los campos');
      return;
    }
    let precioFlete = 0;

    if (this.flete != '' && this.flete) {
      precioFlete = parseFloat(this.flete.replace('.', ''));
      if (precioFlete < 0) {
        this.flete = this.formatNumber('0');
        precioFlete = 0;
      } else {
        this.flete = this.formatNumber(this.flete);
      }
    } else {
      this.flete = 0;
    }

    let equipo = this.equipo;
    let selected = this.lista_equipos.find((eq: any) => {
      return eq.tipoeqid == equipo;
    }).tipoeqname;
    let conversion = parseFloat(this.precio) * parseFloat(this.cantidad);
    if (this.precioDolar != '' && this.precioDolar != '0') {
      conversion =
        (parseFloat(this.precio) + precioFlete) *
        parseFloat(this.precioDolar.replace('.', '').replace(',', '.')) *
        this.cantidad;
    }

    let newDevice = {
      conversion: conversion,
      precio: this.precio,
      precioTotal: parseFloat(this.precio) * parseFloat(this.cantidad),
      cantidad: this.cantidad,
      equipoid: this.equipo,
      equiponame: selected,
    };
    this.loadedSeries.push(newDevice);
    this.clearDevices();
    this.reloadEquipos();
    this.updateFlete();
    this.changeData();
  }

  changeData() {
    this.gridApi.setRowData(this.loadedSeries);
    this.gridApi.setDomLayout('autoHeight');
  }

  clearDevices() {
    this.equipo = null;
    this.cantidad = null;
    this.precio = null;
  }
  newList: Array<any> = [];
  alreadyReload: boolean = false;
  reloadEquipos() {
    if (this.loadedSeries.length > 0) {
      this.newList = this.lista_equipos.filter(
        (eq: any) =>
          !this.loadedSeries.some(serie => serie.equipoid === eq.tipoeqid)
      );
      this.alreadyReload = true;
      return this.newList;
    }
  }
  async handleGridReady(event: GridReadyEvent) {
    this.gridApi = event.api;
    this.columnApi = event.columnApi;
    this.gridApi.setRowData([]);
    this.gridApi.setDomLayout('autoHeight');
  }
  onModelUpdated() {
    if (!this.gridApi) {
      return;
    }
  }
  onSelectionChanged(params: any) {}

  formatNumber(data: string) {
    if (!data || data == '0') return 0;
    let value = data.replace('.', '');
    if (value == null || value == '') {
      return 0;
    }
    let formated = parseFloat(value.toString().replace(',', '.'))
      .toFixed(2)
      .replace('.', ',')
      .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    if (isNaN(parseFloat(formated))) {
      return 0;
    }
    return formated;
  }

  formatMoney(params: any) {
    // Aquí definimos la función para dar formato de dinero con comas como separadores de miles y 2 decimales
    const numericValue = parseFloat(params.value);
    if (!isNaN(numericValue)) {
      return numericValue
        .toFixed(2)
        .replace('.', ',')
        .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }
    return params.value;
  }

  costParser(params: any) {
    let value = params.newValue;
    if (value == null || value === '') {
      return 1;
    }
    value = String(value).replace(',', '.');
    if (isNaN(parseFloat(value))) {
      return 1;
    }
    return parseFloat(value);
  }

  quantityParser(params: any) {
    let value = params.newValue;
    if (value == null || value === '') {
      return 1;
    }
    value = String(value);
    if (isNaN(Number(value))) {
      return 1;
    }
    return Number(value);
  }

  deleteDevice(params: ICellRendererParams) {
    this.loadedSeries = this.loadedSeries.filter(function(serie) {
      return serie.equipoid !== params.data.equipoid;
    });

    this.changeData();
    this.clearDevices();
    this.reloadEquipos();
    this.updateFlete();
  }
  constructor() {
    super();
    let self = this;
    actionsEvent.onEliminar(this.deleteDevice);
    this.columnDefs = [
      {
        headerName: 'Equipo',
        field: 'equiponame',
        resizable: true,
        sortable: true,
        hide: false,
        minWidth: 200,
        width: 200,
        lockPinned: true,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Cantidad',
        field: 'cantidad',
        resizable: true,
        sortable: true,
        hide: false,
        minWidth: 200,
        editable: this.comprobarEdicionEquipos(),
        width: 200,
        lockPinned: true,
        cellStyle: { textAlign: 'left' },
        valueParser: this.quantityParser,
      },
      {
        headerName: 'Precio Unitario',
        field: 'precio',
        resizable: true,
        editable: this.comprobarEdicionEquipos(),
        sortable: true,
        hide: false,
        minWidth: 200,
        width: 200,
        lockPinned: true,
        cellStyle: { textAlign: 'left' },
        valueFormatter: this.formatMoney,
        valueParser: this.costParser,
      },
      {
        headerName: 'Precio Flete Unitario',
        field: 'precioFlete',
        resizable: true,
        sortable: true,
        hide: false,
        minWidth: 200,
        width: 200,
        lockPinned: true,
        cellStyle: { textAlign: 'left' },
        valueFormatter: this.formatMoney,
        valueParser: this.costParser,
      },
      {
        headerName: 'Precio Total Equipos',
        field: 'precioTotal',
        resizable: true,
        sortable: true,
        hide: false,
        minWidth: 200,
        width: 200,
        lockPinned: true,
        cellStyle: { textAlign: 'left' },
        valueFormatter: this.formatMoney,
        valueParser: this.costParser,
      },
      {
        headerName: 'Precio Total Equipos CLP',
        field: 'conversion',
        resizable: true,
        sortable: true,
        hide: true,
        minWidth: 300,
        width: 300,
        lockPinned: true,
        cellStyle: { textAlign: 'left' },
        valueFormatter: this.formatMoney,
        valueParser: this.costParser,
      },
    ];

    this.gridOptions = {
      pagination: true,
      paginationPageSize: 6, //Solución Paginación
      //cacheBlockSize: 50, //Solución Paginación
      //paginationAutoPageSize: false,
      rowModelType: 'normal',
      columnDefs: this.columnDefs,
      //rowModelType: 'serverSide',
      serverSideDatasource: this.serverSide,
      rowSelection: 'single',
      columnTypes: {
        fecha: {
          //cellRenderer: this.fechaFilter,
          sortable: true,
          resizable: true,
          filter: false,
        },
      },
      suppressCsvExport: true,
      suppressExcelExport: true,
      onGridReady: this.handleGridReady,
      onModelUpdated: this.onModelUpdated,
      onSelectionChanged: this.onSelectionChanged,
      onCellEditingStopped: function(event) {
        if (
          event.column.getColId() == 'precio' ||
          event.column.getColId() == 'cantidad'
        ) {
          self.updateDolar();
          if (event.column.getColId() == 'cantidad') {
            self.updateFlete();
          }
        }
      },
      processCellForClipboard: ({ value }) => {},
      onGridSizeChanged: event => {
        //event.api.sizeColumnsToFit();
      },
    };
  }

  pasoActivoIndex = 1;
  pasos = {
    informacionGeneral: {
      accion: 'Crear - Información General',
      visible: true,
      step: 1,
    },
  };

  showInfo: boolean = true;

  /* misc */

  readonly loadingService = new LoadingService();

  /* event handlers */

  async confirmCallback(val: boolean) {
    if (val == true) {
      this.handle_MS_editar();
    }
    this.mostrarModalCONFIRMAR = false;
  }

  handleInfoGeneral() {
    this.showInfo = true;
  }
  editar() {
    if (this.loadedSeries.length == 0) {
      this.$snotify.error('Por favor agregue al menos un equipo');
      return;
    }
    // en el click solo muestro el modal de confirmacion
    this.mostrarModalCONFIRMAR = true;
    //en el callback del editar llamo handle_MS_editar que va al microservicio

    this.Modal_confirmar_TEXTO =
      '¿Está seguro que desea editar la orden de compra ' +
      this.id_orden_compra +
      ' ?';
    if (
      document.querySelector(
        '#modal-mantenedor-container > div.cardnew > div > div > div > div > div > div > div > div > div.ag-root-wrapper-body.ag-layout-auto-height > div.ag-root.ag-unselectable.ag-layout-auto-height > div.ag-body-viewport.ag-row-no-animation.ag-layout-auto-height > div.ag-center-cols-clipper > div > div > div > div.ag-cell.ag-cell-with-height.ag-cell-value.ag-cell-focus.ag-cell-inline-editing > div > input.ag-cell-edit-input'
      ) != null
    ) {
      this.Modal_confirmar_TEXTO =
        'Tiene cambios sin confirmar en la tabla de detalle. ¿Está seguro que desea continuar sin guardar?';
    }
    if (this.estado == 5) {
      this.Modal_confirmar_TEXTO =
        '¿Está seguro que desea Anular la orden de compra ' +
        this.id_orden_compra +
        ' ?';
    }
  }

  getCliente() {
    /*  TODO VERIFICAR */
    let user = localStorage.getItem('user');
    let clienteDefecto = JSON.parse(
      localStorage.getItem('user').replace(/'/g, '"')
    ).clienteDefecto;
    return clienteDefecto;
  }

  async handle_MS_editar() {
    //estado
    let estadoSelected = this.lista_estados.find(
      (e: any) => e.configid == this.estado
    ).configvalor;
    //proveedor
    let proveedorSelected = this.lista_proveedores.find(
      (e: any) => e.proveedorrut == this.rut_proveedor
    ).proveedorrazon;
    this.loadingService.showLoading(undefined, 'editar');
    return fetchOrdenesCompra(
      {
        id_orden_compra: this.id_orden_compra, //USAMOS EL VALOR QUE VIENE DESDE LA PANTALLA ANTERIOR
        descrip: this.descrip,
        observacion: this.observacion,
        solicitado_por: this.solicitadoPor,
        fecha_emision: this.fecha_alta,
        fecha_llegada: this.fecha_llegada,
        cuenta_costo: this.rut_contable,
        rut_proveedor: this.rut_proveedor,
        'razón social proveedor': proveedorSelected,
        estado: this.estado,
        'estado seleccionado': estadoSelected,
        user_id: this.getUserID(),
        id_usuario: this.getUserID(),
        id_cliente: this.getCliente(),
        flete: this.flete.toString().replace('.', ''),
        precio_dolar: this.esInternacional
          ? this.precioDolar.toString().replace('.', '')
          : '0',
        equipos: this.loadedSeries,
        modulo_id: '147',
      },
      'conectaOrdenesCompra/editar'
    )
      .then((data: any) => {
        this.loadingService.hideLoading('editar');
        if (Number(data.data.CODIGO_RESPUESTA) > 1) {
          this.$snotify.error(data.data.MENSAJE_RESPUESTA);
        } else {
          this.$snotify.success(data.data.MENSAJE_RESPUESTA);
        }

        this.closeModal();
      })
      .catch((error: any) => {
        return null;
      })
      .finally(() => {
        return null;
      });
  }

  async prefill_dropdowns() {
    const EQ = await this.getEqupos();
    this.lista_equipos = EQ.LISTA;

    const EST = await this.get_lista_estados();
    this.lista_estados = EST.LISTA;

    const PROV = await this.get_lista_proveedores();
    this.lista_proveedores = PROV.LISTA;

    if (this.id_orden_compra) {
      this.handleProveedorChange();
    }

    //const PROXIMO_ID = await this.get_proximo_id_ms();

    //const GET_INET = await this.get_configs_inet();
  }
  equiposSelected: any;
  estadoOC: any = '';
  estadoAuto: any = '';
  async pull_data_from_orden_compra() {
    const OC = await this.getOrders_by_id(this.id_orden_compra);
    this.id_orden_compra = OC['Compra Número'];
    this.valor_id_orden_compra = OC['Compra Número'];
    this.loadedSeries =
      (await this.getEquiposSelected(this.id_orden_compra)) || [];
    this.descrip = OC['Descripción'];
    this.observacion = OC['Observación Compra'];
    this.solicitadoPor = OC['Solicitado Por'];
    this.fecha_alta = moment(OC['Fecha Emisión'], 'YYYY-MM-DD');
    this.fecha_llegada = moment(OC['Fecha Llegada'], 'YYYY-MM-DD');
    this.rut_contable = OC['Cuenta Costo'];
    this.rut_proveedor = OC['Rut Proveedor'];
    this.equipo = OC['tipoeq'];
    this.estadoOC = OC['compraestado'];
    this.estadoAuto = OC['Estado de Autorización'];
    this.flete = this.formatNumber(OC['Flete'].replace('.', ','));
    this.precioDolar = this.formatNumber(OC['Precio Dolar'].replace('.', ','));
    this.estadoAuto = OC['Estado de Autorización'];
    //this.cantidad = OC['Cantidad Solicitada'];
    //this.precio = OC['Precio'];
    this.estado = OC['compraestado'];
    this.reloadEquipos();
    //this.changeData();
    this.updateFlete();
    this.updateDolar();
  }

  async loadInfo() {
    await this.prefill_dropdowns();
  }

  mounted() {
    this.loadInfo();
    this.initialize();
    this.registrarValidadores();

    if (this.id_orden_compra) {
      this.pull_data_from_orden_compra();
    }
    if (
      this.editable == 'EN STOCK' ||
      this.editable == 'ANULADO' ||
      this.editable == 'STOCK PARCIAL'
    ) {
      this.deshabilitado = true;
      if (this.editable == 'ANULADO')
        this.$snotify.warning(
          'La solicitud está anulada, No es posible Editar',
          {
            timeout: 3000,
          }
        );
    }
  }

  getUserID(): any {
    let user = localStorage.getItem('user');
    let id = JSON.parse(user.replace(/'/g, '"')).id;
    return id;
  }

  ModalConfirmarCreacion: boolean = false;
  ModalConfirmarCreacion_TEXTO: string = '';
  validarGrilla() {
    if (this.validavacios() == false) {
      return 0;
    }

    if (
      document.querySelector(
        '#modal-mantenedor-container > div.cardnew > div > div > div > div > div > div > div > div > div.ag-root-wrapper-body.ag-layout-auto-height > div.ag-root.ag-unselectable.ag-layout-auto-height > div.ag-body-viewport.ag-row-no-animation.ag-layout-auto-height > div.ag-center-cols-clipper > div > div > div > div.ag-cell.ag-cell-with-height.ag-cell-value.ag-cell-focus.ag-cell-inline-editing > div > input.ag-cell-edit-input'
      ) != null
    ) {
      this.ModalConfirmarCreacion_TEXTO =
        'Tiene cambios sin confirmar en la tabla de detalle. ¿Está seguro que desea continuar sin guardar?';
      this.ModalConfirmarCreacion = true;
    } else {
      this.crear(true);
    }
  }

  async crear(data: boolean) {
    if (!data) {
      this.ModalConfirmarCreacion = false;
      return;
    }

    //estado
    let estadoSelected = this.lista_estados.find(
      (e: any) => e.configid == this.estado
    ).configvalor;
    //proveedor
    let proveedorSelected = this.lista_proveedores.find(
      (e: any) => e.proveedorrut == this.rut_proveedor
    ).proveedorrazon;

    this.loadingService.showLoading(undefined, 'crear');
    return fetchOrdenesCompra(
      {
        //MANDAMOS EL VALOR DEL TEXTBOX CON EL ID
        descrip: this.descrip,
        observacion: this.observacion,
        solicitado_por: this.solicitadoPor,
        fecha_emision: this.fecha_alta,
        fecha_llegada: this.fecha_llegada,
        cuenta_costo: this.rut_contable,
        rut_proveedor: this.rut_proveedor,
        'razón social proveedor': proveedorSelected,
        estado: this.estado,
        'estado seleccionado': estadoSelected,
        user_id: this.getUserID(),
        id_usuario: this.getUserID(),
        id_cliente: this.getCliente(),
        flete: this.flete.toString().replace('.', ''),
        precio_dolar: this.esInternacional
          ? this.precioDolar.toString().replace('.', '')
          : '0',
        equipos: this.loadedSeries,
        modulo_id: '147',
      },
      'conectaOrdenesCompra/crear'
    )
      .then((data: any) => {
        this.loadingService.hideLoading('crear');
        if (Number(data.data.CODIGO_RESPUESTA) > 1) {
          this.$snotify.error(data.data.MENSAJE_RESPUESTA);
        } else {
          this.$snotify.success(data.data.MENSAJE_RESPUESTA);
          this.closeModal();
        }
      })
      .catch((error: any) => {
        return null;
      })
      .finally(() => {
        return null;
      });
  }

  async getEqupos() {
    this.loadingService.showLoading(undefined, 'getEqupos');
    return fetchOrdenesCompra(
      {
        id_usuario: this.getUserID(),
        id_cliente: this.getCliente(),
        modulo_id: '147',
      },
      'conectaGetTipoEQ'
    )
      .then((data: any) => {
        this.loadingService.hideLoading('getEqupos');
        const obj: any = data.data.data;

        return obj;
      })
      .catch((error: any) => {
        return null;
      })
      .finally(() => {
        return null;
      });
  }

  async getEquiposSelected(oc: any) {
    this.loadingService.showLoading(undefined, 'get_equipos_selected');
    return fetchOrdenesCompra(
      {
        compra: oc,
      },
      'conectaOrdenesCompra/get_equipos_selected'
    )
      .then((data: any) => {
        this.loadingService.hideLoading('get_equipos_selected');
        return data.data.data.LISTA;
      })
      .catch((error: any) => {
        return [];
      })
      .finally(() => {
        return [];
      });
  }

  async getOrders_by_id(oc: any) {
    this.loadingService.showLoading(undefined, 'getOrders_by_id');
    return fetchOrdenesCompra(
      {
        id_orden_compra: oc,
        id_usuario: this.getUserID(),
        id_cliente: this.getCliente(),
        modulo_id: '147',
        orden_compra: this.id_orden_compra,
        not_filtered: true,
      },
      'conectaOrdenesCompra'
    )
      .then((data: any) => {
        this.loadingService.hideLoading('getOrders_by_id');
        return data.data.data;
      })
      .catch((error: any) => {
        return null;
      })
      .finally(() => {
        return null;
      });
  }

  async get_lista_proveedores() {
    this.loadingService.showLoading(undefined, 'get_lista_proveedores');
    return fetchOrdenesCompra(
      {
        id_usuario: this.getUserID(),
        id_cliente: this.getCliente(),
        modulo_id: '147',
      },
      'conectaOrdenesCompra/get_lista_proveedores'
    )
      .then((data: any) => {
        this.loadingService.hideLoading('get_lista_proveedores');
        return data.data.PROVEEDORES;
      })
      .catch((error: any) => {
        return null;
      })
      .finally(() => {
        return null;
      });
  }

  async get_lista_estados() {
    this.loadingService.showLoading(undefined, 'get_lista_estados');
    return fetchOrdenesCompra(
      {
        id_usuario: this.getUserID(),
        id_cliente: this.getCliente(),
        modulo_id: '147',
        id_orden_compra: this.id_orden_compra,
      },
      'conectaOrdenesCompra/get_lista_estados'
    )
      .then((data: any) => {
        this.loadingService.hideLoading('get_lista_estados');
        if (data.data.bloquea_dropdown == true) {
          this.bloquea_dropdown_estado = true;
        }
        return data.data.ESTADOS;
      })
      .catch((error: any) => {
        return null;
      })
      .finally(() => {
        return null;
      });
  }

  inputdate() {}

  closeModal() {
    this.$emit('modalOrdenCompraEmit', false);
    this.loadedSeries = [];
  }

  initialize() {
    this.dictionaryFormErrors = {
      custom: {
        precio: {
          required: () => config.errorMensajes.textoRequerido,
          numeric: config.errorMensajes.soloNumeros,
        },
      },
    };
    this.$validator.localize('es', this.dictionaryFormErrors);
  } //end initialize()

  private registrarValidadores() {
    const self = this;
    Validator.extend('validateNumberAndSemicolon', {
      getMessage(field: any, params: any, data: any) {
        return (
          (data && data.message) || '* El campo solo puede incluir números'
        );
      },
      validate(value: any) {
        return new Promise(resolve => {
          resolve({
            valid: /^[0-9,.]*$/.test(value),
            data:
              value == true
                ? undefined
                : {
                    message: '* El campo solo puede incluir números',
                  } /*  podria ir disabled del boton enviar */,
          });
        });
      },
    });
    Validator.extend('canti', {
      getMessage(field: any, params: any, data: any) {
        return (
          (data && data.message) || '* El campo solo puede incluir números'
        );
      },
      validate(value: any) {
        return new Promise(resolve => {
          resolve({
            valid: /^[0-9,.]*$/.test(value),
            data:
              value == true
                ? undefined
                : {
                    message: '* El campo solo puede incluir número',
                  },
          });
        });
      },
    });
    Validator.extend('codopera', {
      getMessage(field: any, params: any, data: any) {
        return (
          (data && data.message) || '* El campo solo puede incluir números'
        );
      },
      validate(value: any) {
        return new Promise(resolve => {
          resolve({
            valid: /^[0-9]*$/.test(value),
            data:
              value == true
                ? undefined
                : {
                    message: '* El campo solo puede incluir número',
                  },
          });
        });
      },
    });
  } // end regitrarValidadores

  validavacios() {
    let OK = true;

    if (this.descrip == null || this.descrip == '') {
      this.$snotify.error('Descripción es mandatorio');
      OK = false;
      return OK;
    }

    if (this.esInternacional == true && this.precioDolar == '') {
      this.$snotify.error(
        'Tipo de cambio es mandatorio para proveedor internacional'
      );
      OK = false;
      return OK;
    }

    if (this.rut_contable == null || this.rut_contable == '') {
      this.$snotify.error('Cuenta costo es mandatorio');
      OK = false;
      return OK;
    }
    if (this.rut_proveedor == null || this.rut_proveedor == '') {
      this.$snotify.error('Razón es mandatorio');
      OK = false;
      return OK;
    }

    if (this.estado == null || this.estado == '') {
      this.$snotify.error('Estado es mandatorio');
      OK = false;
      return OK;
    }

    if (this.loadedSeries.length == 0) {
      this.$snotify.error('Por favor agregue al menos un equipo');
      OK = false;
      return OK;
    }
    return OK;
  } // end validavacios
}
